import React from "react";

/**
 * Captura errores de renderizado para que la aplicación no quede en blanco.
 * React desmonta todo el árbol ante una excepción no controlada, por eso sin
 * este componente cualquier dato inesperado deja la pantalla vacía.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error de renderizado:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 15,
            minHeight: "60vh",
            padding: 20,
            textAlign: "center",
            fontFamily: "Roboto, sans-serif",
          }}
        >
          <h2>Ocurrió un error inesperado</h2>
          <p>
            No fue posible mostrar esta sección. Por favor, intente nuevamente.
          </p>
          <button
            onClick={() =>
              window.location.assign(
                process.env.NODE_ENV === "development" ? "/" : "/tramites",
              )
            }
            style={{
              backgroundColor: "#1E8449",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              fontSize: 14,
              padding: "10px 20px",
            }}
          >
            Volver al inicio
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
